import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { LoginRequest, LoginResponse } from '../models';
import { MockAuthService } from './mock-auth.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly mockAuthService = inject(MockAuthService);

  login(request: LoginRequest): Observable<LoginResponse> {
    if (environment.useMockData && !environment.production) {
      return this.mockAuthService.login(request);
    }

    return this.http.post<LoginResponse>(this.buildApiUrl('/api/auth/login'), request, {
      withCredentials: true,
    });
  }

  private buildApiUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`;
  }
}
